<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 bg-white z-50 flex items-center justify-center p-3 sm:p-4"
  >
    <div class="text-center max-w-xs sm:max-w-sm mx-auto">
      <div class="relative mb-3 sm:mb-4 md:mb-6">
        <!-- Main Spinner -->
        <div
          class="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 border-3 sm:border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto"
        ></div>
        <!-- Inner Spinner -->
        <div
          class="absolute inset-0 w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 border-3 sm:border-4 border-transparent border-r-blue-400 rounded-full animate-spin mx-auto"
          style="animation-direction: reverse; animation-duration: 1.5s"
        ></div>
      </div>
      <div class="space-y-1 sm:space-y-2">
        <h3 class="text-base sm:text-lg md:text-xl font-semibold text-gray-800">
          {{ message }}
        </h3>
        <p class="text-xs sm:text-sm text-gray-600 px-2">
          Please wait while we load student data...
        </p>
        <!-- Loading Progress Dots -->
        <div class="flex justify-center space-x-1 mt-3 sm:mt-4">
          <div
            class="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-600 rounded-full animate-pulse"
          ></div>
          <div
            class="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-600 rounded-full animate-pulse"
            style="animation-delay: 0.1s"
          ></div>
          <div
            class="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-600 rounded-full animate-pulse"
            style="animation-delay: 0.2s"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    isVisible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Loading...",
    },
  });
</script>
